import { Link } from 'react-router-dom';
import { Container } from "react-bootstrap";

function Header() {
    const webDate = new Date();
    const year = webDate.getFullYear();
    const month = webDate.getMonth() + 1;

    return (
        <div className="bg-white border-bottom py-2">
            <Container className="d-flex align-items-center">
                <div className='d-flex justify-content-between w-100 align-items-center'>
                    <Link to="/home" className='text-decoration-none text-primary fs-3 me-2 fw-bolder'>imza.</Link>

                    <div>
                        <Link className="text-decoration-none text-dark me-4" to="/home">Ana Sayfa</Link>
                        {localStorage.getItem('userRole') > 0 && <Link className="text-decoration-none text-dark me-4" to="/user">Kullanıcılar</Link>}
                        {localStorage.getItem('userRole') == 2 && <Link className="text-decoration-none text-dark me-4" to="/site">Siteler</Link> }
                        {localStorage.getItem('userRole') > 0 && <Link className="text-decoration-none text-dark me-4" to="/payment">Ödemeler</Link>}

                        <Link className="text-decoration-none text-dark" to="/logout">Çıkış Yap</Link>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Header;
